import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const InnerWrapper = styled("div")`
    display: flex;
    height: 2.75rem;
    flex: 1 1 0;
    background-color: inherit;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    align-items: center;
    max-width: ${breakpoints.values.xl}px;
    border-bottom: 1px solid;
    border-color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.secure.borderColor};
    padding: 0.4rem 0;

    @media (min-width: ${breakpoints.values.md}px) {
        height: 3.75rem;
    }

    @media (max-width: ${breakpoints.values.xl}px) {
        padding: 0.5rem 2.75rem 0.5rem 1.3125rem;
    }

    @media (max-width: ${breakpoints.values.lg}px) {
        padding: 0.5rem 2.25rem 0.5rem 0.785rem;
    }

    @media (max-width: ${breakpoints.values.md}px) {
        padding: 0.5rem 2.25rem 0.5rem 0.785rem;
    }

    @media (max-width: ${breakpoints.values.sm}px) {
        padding: 0.5rem 0.575rem 0.5rem 0;
    }

    .header-adaptive-brand a {
        height: auto;
    }

    .shoppingbag {
        height: auto;
        width: auto;
    }

    .countrylangselector {
        button {
            pointer-events: none;
        }
        padding-left: 0.875rem;
    }
`
